import React from 'react';
import { connect } from 'react-redux';
import { pipe, values, all, equals } from 'ramda';
import { updateIPRange, addIPRange, removeIPRange, changeSecuritySetting } from '../../actions/reduxActions/currentTenant';
import Table from '../Table';
import TextEditor from '../TextEditor';

export const SecurityIPSetting = ({
    IPRange,
    isActive,
    settingPropertyName,
    rangeEntries,
    labelText,
    updateIPRange,
    removeIPRange,
    addIPRange,
    changeSecuritySetting,
}) => {

    const allValuesEmptyString = pipe(
        values,
        all(equals('')),
    );

    const columns = [
        {
            renderHeader: () => 'Actions',
            renderCell: ({ rowIndex }) => (
                <React.Fragment>
                    <button
                        className="btn-icon"
                        onClick={() => removeIPRange({
                            IPRange,
                            index: rowIndex,
                        })}
                    >
                        <span className="glyphicon glyphicon-trash" />
                    </button>
                </React.Fragment>
            ),
            size: '1px',
        },
        {
            renderHeader: () => 'Name',
            renderCell: ({ item: rangeEntry, rowIndex }) => (
                <TextEditor
                    isEditing={allValuesEmptyString(rangeEntry)}
                    text={rangeEntry.developerName}
                    onChange={({ target }) => updateIPRange({
                        IPRange,
                        index: rowIndex,
                        rangeEntry: {
                            ...rangeEntries[rowIndex],
                            developerName: target.value,
                        },
                    })}
                />
            ),
        },
        {
            renderHeader: () => 'Summary',
            renderCell: ({ item: rangeEntry, rowIndex }) => (
                <TextEditor
                    text={rangeEntry.developerSummary}
                    onChange={({ target }) => updateIPRange({
                        IPRange,
                        index: rowIndex,
                        rangeEntry: {
                            ...rangeEntries[rowIndex],
                            developerSummary: target.value,
                        },
                    })}
                />
            ),
        },
        {
            renderHeader: () => 'Start IP Address',
            renderCell: ({ item: rangeEntry, rowIndex }) => (
                <TextEditor
                    text={rangeEntry.startIPAddress}
                    onChange={({ target }) => updateIPRange({
                        IPRange,
                        index: rowIndex,
                        rangeEntry: {
                            ...rangeEntries[rowIndex],
                            startIPAddress: target.value,
                        },
                    })}
                />
            ),
        },
        {
            renderHeader: () => 'End IP Address',
            renderCell: ({ item: rangeEntry, rowIndex }) => (
                <TextEditor
                    text={rangeEntry.endIPAddress}
                    onChange={({ target }) => updateIPRange({
                        IPRange,
                        index: rowIndex,
                        rangeEntry: {
                            ...rangeEntries[rowIndex],
                            endIPAddress: target.value,
                        },
                    })}
                />
            ),
        },
    ];

    return (
        <React.Fragment>
            <div className="checkbox">
                <label>
                    <input
                        className="ip-setting-enable"
                        type="checkbox"
                        checked={isActive}
                        onChange={({ target }) => changeSecuritySetting({
                            settingName: settingPropertyName,
                            value: target.checked,
                        })}
                    />
                    {labelText}
                </label>
            </div>

            <div className={`security-ip-range ${isActive ? '' : 'hidden'}`}>
                <Table
                    columns={columns}
                    items={rangeEntries}
                />
                <button
                    className="link-emulate add-range"
                    onClick={() => addIPRange({
                        IPRange,
                        rangeEntry: {
                            developerName: '',
                            developerSummary: '',
                            startIPAddress: '',
                            endIPAddress: '',
                        },
                    })}
                >
                    <span className="glyphicon glyphicon-plus-sign" />
                    { ' Add an IP Range' }
                </button>
            </div>
        </React.Fragment>
    );
};

const mapDispatchToProps = {
    updateIPRange,
    removeIPRange,
    addIPRange,
    changeSecuritySetting,
};

export default connect(
    null,
    mapDispatchToProps,
)(SecurityIPSetting);
